"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var material_1 = require("@mui/material");
var react_1 = __importDefault(require("react"));
var useIsSmallScreen_1 = __importDefault(require("../hooks/useIsSmallScreen"));
var classes = {
    jobLabel: {
        padding: 2,
        color: function (theme) { return theme.palette.primary.dark; },
        borderRadius: '10px',
        background: '#F4F2F4',
        textAlign: 'center',
    },
};
function Specifications(_a) {
    var vacancy = _a.vacancy;
    var isSmallScreen = (0, useIsSmallScreen_1.default)();
    return ((0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ container: true, item: true, gap: isSmallScreen ? 0 : 3, sx: { justifyContent: isSmallScreen ? 'space-between' : 'normal' } }, { children: [(0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ sx: __assign(__assign({}, classes.jobLabel), { minWidth: isSmallScreen ? 90 : 50 }), item: true }, { children: vacancy.minimumHours === vacancy.maximumHours ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [vacancy.minimumHours, " uur"] })) : ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [vacancy.minimumHours, " - ", vacancy.maximumHours, " uur"] })) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ sx: __assign(__assign({}, classes.jobLabel), { minWidth: isSmallScreen ? 90 : 50 }), item: true }, { children: vacancy.minimumEducationalLevel.name })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ sx: __assign(__assign({}, classes.jobLabel), { minWidth: isSmallScreen ? 90 : 50 }), item: true }, { children: vacancy.contractType }))] })));
}
exports.default = Specifications;
